<template>
    <div class="audiomain" >
        <audio ref="audio" id="audio"  :src="$store.state.audio.music&&$store.state.audio.music.audioUrl" preload @ended="isNext"></audio>
        <div class="imgwarp">
            <img ref="pic" id="pic" :src="$store.state.audio.music&&$store.state.audio.music.pictureUrl">
        </div>
        <div class="infowarp">
            <p class="title ellipse">{{$store.state.audio.music&&$store.state.audio.music.collectionName}}</p>
            <p class="time">{{time}}</p>
        </div>
        <div class="conwarp">
            <div class="ico">
                <img src="../../../static/images/audio/leftPlay.png" ref="pre" id="pre" @click.stop="isPre">
            </div>
            <div class="icos">
                <img src="../../../static/images/audio/play.png" ref="play" v-show="!showPlayStop" id="play" @click="isPlay">
                <img src="../../../static/images/audio/pause.png" id="stop" v-show="showPlayStop" @click="isStops">
            </div>
            <div class="ico">
                <img src="../../../static/images/audio/rightPlay.png" ref="next" id="next" @click.stop="isNext">
            </div>
            <div class="ico">
                <img src="../../../static/images/audio/close1.png" @click.stop="isStop">
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapActionss } from 'vuex'
export default {
    name: 'app',

    data(){
        return{
         apiUrl: 'http://www.egtch.com/t_works/Vuedata/data.php',
          id: 0,
          bg:'',
          time:"00:00",
          showList: false,
          showPlayStop:true
        }
    },
    /*computed: {
        ...mapState('audio',[
            'audioIndex',
            'music',
            'MList',
        ])
    },*/
  computed: mapState({
    count:state=>state.audio.playing
  }),
    mounted(){
        let _this = this;

        setInterval(function (){
            var audio = document.getElementById("audio");
            _this.time = audio && audio.currentTime && _this.formatSeconds(audio.currentTime);
        },1000);
        //this.getMusic(this.$store.state.audio.audioIndex);
        // this.isBg();
    },
    watch:{
        'id':'getMusic',
        'bg':'isBg',
        count:function (newval,oldval) {
          if(this.$store.state.audio.audioshow){
            if(newval){
              this.showPlayStop=true;
            }else{
              this.showPlayStop=false;
            }
          }else{
            this.showPlayStop=false;
          }

},
    },
    methods:{
        getMusic(p){
            this.$store.state.audio.music="";
            document.getElementById("audio").currentTime="0";
            this.id = this.$store.state.audio.audioIndex
            document.getElementById("audio").play();
            this.$store.state.audio.playing=true;
                if(p < this.$store.state.audio.MList.length) {
                    // this.music = response.music[p]
                    this.$store.state.audio.music = this.$store.state.audio.MList[this.$store.state.audio.audioIndex]
                }
                if(p > this.$store.state.audio.MList.length){
                    this.id = 0
                    this.$store.state.audio.audioIndex = 0
                    this.$store.state.audio.music = this.$store.state.audio.MList[this.$store.state.audio.audioIndex]
                }
                if(p < 0){
                    this.id = this.$store.state.audio.MList.length
                    this.$store.state.audio.audioIndex = this.$store.state.audio.MList.length
                    this.$store.state.audio.music = this.$store.state.audio.MList[this.$store.state.audio.audioIndex]
                }

          //  })
        },
        /*查看当前audio是否正在播放，如果停止，那么播放下一曲*/
        isPlay(){
            document.getElementById("audio").play();
          this.$store.state.audio.playing=true;
            this.showPlayStop=true
            // document.getElementById("play").style.display = "none";
            // document.getElementById("stop").style.display = "inline";
            // document.getElementById("pic").style.animationPlayState = "running";
            //console.log(+this.$refs.play+this.$refs.stop+this.$refs.pic);
            return false
        },
        isStop(){
            this.$store.dispatch('hideAudio');
            document.getElementById("audio").pause();
            this.$store.state.audio.playing=false;
            this.showPlayStop=false
            // document.getElementById("stop").style.display = "none";
            // document.getElementById("play").style.display = "inline";
            // document.getElementById("pic").style.animationPlayState = "paused";
            return false
        },
      isStops(){
        document.getElementById("audio").pause();
        this.$store.state.audio.playing=false;
        this.showPlayStop=false;
        // document.getElementById("stop").style.display = "none";
        // document.getElementById("play").style.display = "inline";
        // document.getElementById("pic").style.animationPlayState = "paused";
        return false
      },
        isNext(){
            this.id++;
            this.$store.state.audio.audioIndex++;
            /*为了防止停止状态下，点击下一曲的时候，停止图标不出现，并且专辑图片不转动*/
            // document.getElementById("play").style.display="none";
            // document.getElementById("stop").style.display="inline";
            // document.getElementById("item-"+this.bg).style.background='none';
            // document.getElementById("pic").style.animationPlayState="running";
        },
        isPre(){
            this.id--;
            this.$store.state.audio.audioIndex--;
            // document.getElementById("play").style.display="none";
            // document.getElementById("stop").style.display="inline";
            // document.getElementById("pic").style.animationPlayState="running";
        },
        isShow(){
            this.showList = true
        },
        isClose(){
            this.showList = false
        },
        isBg(){
            this.bg = this.id
            document.getElementById("item-"+this.bg).style.background='#ff0000';
        },
        /*点击列表中的歌曲，并播放*/
        clickSong(i){
            this.id = i;
            document.getElementById("item-"+this.bg).style.background='none';
            document.getElementById("play").style.display="none";
            document.getElementById("pic").style.animationPlayState="running";
            this.isBg()
        },


        formatSeconds(value) {
            var hh = parseInt(value/3600);
            if(hh<10) hh = "0" + hh;
            var mm = parseInt((value-hh*3600)/60);
            if(mm<10) mm = "0" + mm;
            var ss = parseInt((value-hh*3600)%60);
            if(ss<10) ss = "0" + ss;
            // var length = hh + ":" + mm + ":" + ss;
            var length =  mm + ":" + ss;
            if(value>0){
                return length;
            }else{
                return "NaN";
            }
        }

    }
}
</script>

<style scoped>
.audiomain{
    border: 1px solid #ededed;
    width:100%;
    height:1.5rem;
    background:#F1F1F1;
    display: flex;
    flex-direction: row;
    align-items: center;
    position: fixed;
    padding:.75rem 1.25rem ;
    top: 2.25rem;
    z-index: 10000;
}
.audioTopIndexClass{
    margin-top: 0;
    position: absolute;
}
.imgwarp{
    width:2rem;
    height:1.5rem;

    margin: 0 0.19rem;
}
.imgwarp img{
  width:2rem;
  height:1.5rem;
}
.infowarp{
    width:6rem;
}
.infowarp .title{
  width:6rem;
  height:1rem;
  font-size:0.7rem;
  font-family:PingFangSC-Regular;
  font-weight:400;
  color:rgba(102,102,102,1);
  line-height:1rem;
}
.ellipse{
  overflow:hidden;
text-overflow:ellipsis;
white-space:nowrap;
}
.infowarp .time{
  height:0.85rem;
  font-size:0.6rem;
  font-family:PingFang-SC-Regular;
  font-weight:400;
  color:rgba(185,185,185,1);
  line-height:0.85rem;
}
.conwarp{
   width: 7rem;
  display: flex;
  justify-content: space-around;
  line-height: 1rem;
}
.conwarp .ico{
    display: inline-block;
    margin-right: 0.05rem;
}
.ico img{
    width:0.6rem;
    height:0.6rem;
}
.icos img{
  width:1rem;
  height:1rem;
  margin-top: .05rem;
}
</style>



// WEBPACK FOOTER //
// src/components/audio/audioTop.vue